import * as jQuery from 'jquery';
import { isSnapshotView } from './utils';

/**
 * Calculate the height of configurable UI sections and update CSS variables.
 *
 * The CSS variables are used to calculate the available viewport height
 * for the configurator layout on desktop.
 */
export function updateConfiguratorLayoutCssVariables(): void {
	let adminPriceHeight = 0;
	let wrapPriceHeight = 0;
	let shedTypeHeight = 0;
	let disclaimerHeight = 0;
	let navbarHeight = 0;

	const adminPriceWrap = jQuery('.show-admin-price-wrap');
	if (adminPriceWrap.length && adminPriceWrap.is(':visible')) {
		adminPriceHeight = adminPriceWrap.outerHeight(true) || 0;
	}
	const wrapPriceCart = jQuery('.wrap-price-add-to-cart');
	if (wrapPriceCart.length && wrapPriceCart.is(':visible')) {
		wrapPriceHeight = wrapPriceCart.outerHeight(true) || 0;
	}
	const shedType = jQuery('.ssb-configurator-shed-type');
	if (shedType.length && shedType.is(':visible')) {
		shedTypeHeight = shedType.outerHeight(true) || 0;
	}
	const disclaimer = jQuery('.pricing-disclaimer');
	if (disclaimer.length && disclaimer.is(':visible')) {
		disclaimerHeight = disclaimer.outerHeight(true) || 0;
	}

	const navbar = jQuery('#wrapper-navbar nav.navbar');
	if (navbar.length && navbar.is(':visible')) {
		navbarHeight = navbar.outerHeight(true) || 0;
	}

	// Set CSS variables for desktop height calculation
	document.documentElement.style.setProperty('--ssb-admin-price-height', adminPriceHeight + 'px');
	document.documentElement.style.setProperty('--ssb-wrap-price-height', wrapPriceHeight + 'px');
	document.documentElement.style.setProperty('--ssb-shed-type-height', shedTypeHeight + 'px');
	document.documentElement.style.setProperty('--ssb-disclaimer-height', disclaimerHeight + 'px');
	document.documentElement.style.setProperty('--ssb-navbar-height', navbarHeight + 'px');

	// Set popup top position CSS variable for overlay positioning
	const canvasEl = jQuery('.ssb-model-canvas-wrapper');
	if (canvasEl.length) {
		const popupTop = navbarHeight + (canvasEl.outerHeight() || 0);
		document.documentElement.style.setProperty('--ssb-popup-top', popupTop + 'px');
	}
}

/**
 * Update the visibility (show/hide) of the price element on the mobile sticky bar.
 * @param show True to show the price, false to hide it
 */
export function updateStickyBarPriceVisibility(show: boolean): void {
	const stickyBar = jQuery('.ssb-mobile-sticky-bar');
	if (stickyBar.length) {
		if (show) {
			stickyBar.removeClass('hide-price');
		} else {
			stickyBar.addClass('hide-price');
		}
	}
}

/**
 * Update the price amount text displayed on the mobile sticky bar.
 * @param priceValue The formatted price value string to display
 */
export function updateStickyBarPriceValue(priceValue: string): void {
	const priceAmount = jQuery('.ssb-mobile-sticky-bar .price-amount');
	if (priceAmount.length && priceValue) {
		priceAmount.text(priceValue);
	}
}

/**
 * Initialize the mobile sticky bar if the viewport is mobile/tablet size.
 * Removes the sticky bar if the viewport is desktop.
 */
export function initMobileStickyBar(): void {
	if (jQuery('.ssb-mobile-sticky-bar').length) {
		return;
	}

	const mainSubmitBtn = jQuery('.woocommerce-page.single div.product div.summary').find(
		'.group-button',
	);

	const targetBtn =
		mainSubmitBtn.length && mainSubmitBtn.is(':visible')
			? mainSubmitBtn
			: jQuery('.woocommerce-page.single div.product div.summary').find(
					'.single_add_to_cart_button',
				);

	let submitBtnText = 'Submit Quote';
	if (targetBtn.length) {
		const targetBtnText = targetBtn.text() || targetBtn.val();
		if (targetBtnText) {
			submitBtnText = (targetBtnText as string).trim();
		}
	}

	if (isSnapshotView()) {
		submitBtnText = 'Keep Designing';
	}

	// Check if we are in mobile v2 mode using the global setting variable
	const w = <any>window;
	const isMobileV2 = w['shedpro'] && w['shedpro']['is_mobile_v2'] == '1';

	const shedDetailBtnHtml = isMobileV2
		? `
			<button type="button" class="button btn-shed-detail btn-sticky-detail icon-file-text" title="Shed detail"></button>
		`
		: '';

	let buttonQuote = `<button class="button sticky-bar-submit-btn">${submitBtnText}</button>`;
	if (isSnapshotView()) {
		const hrefURL = jQuery('.wrapper-keep-design .btn-keep-design').attr('href') || '#';
		buttonQuote = `<a class="button sticky-bar-keep-design" href="${hrefURL}">${submitBtnText}</a>`;
	}

	// Create the sticky bottom bar element
	const stickyBar = jQuery(`
		<div class="ssb-mobile-sticky-bar">
			<div class="sticky-bar-price">
				<span class="price-label">Est Price:</span>
				<span class="price-amount">$0.00</span>
			</div>
			<div class="sticky-bar-actions">
				${shedDetailBtnHtml}
				${buttonQuote}
			</div>
		</div>
	`);

	const submitBtn = stickyBar.find('.sticky-bar-submit-btn');

	// Bind click event directly to sticky bar submit button inside the element
	submitBtn.on('click', function (e) {
		e.preventDefault();
		e.stopPropagation(); // Prevent event bubbling to document which would immediately close the popup

		if (jQuery(this).prop('disabled') || jQuery(this).hasClass('disabled')) {
			return;
		}

		const groupButtons = jQuery('.group-buttons');
		if (groupButtons.length) {
			jQuery('.group-buttons, .group-checkout-overlay').toggleClass('active');
		} else {
			const mainCartBtn = jQuery('.woocommerce-page.single div.product div.summary').find(
				'.single_add_to_cart_button',
			);
			if (mainCartBtn.length) {
				mainCartBtn.trigger('click');
			}
		}
	});

	// Append sticky bottom bar to body to stay fixed at footer
	jQuery('body').append(stickyBar);

	// Listen for scroll events on .summary to show/hide the sticky bottom bar
	const summary = jQuery('.woocommerce-page.single div.product div.summary');
	summary.off('scroll.stickybar').on('scroll.stickybar', function () {
		let target = summary.find('.group-button-checkout-inner');
		if (!target.length || !target.is(':visible')) {
			target = summary.find('.single_add_to_cart_button');
		}

		if (target.length && target.is(':visible')) {
			const targetTop = target.position().top;
			// If the target element is scrolled past the top of the summary container
			if (targetTop + (target.outerHeight() || 0) < 0) {
				jQuery('.ssb-mobile-sticky-bar').addClass('visible');
			} else {
				jQuery('.ssb-mobile-sticky-bar').removeClass('visible');
			}
		} else {
			// If target is not visible or not found, show sticky bar
			jQuery('.ssb-mobile-sticky-bar').addClass('visible');
		}
	});
}

/**
 * Check if the current viewport width indicates a mobile/tablet layout (<= 1024px).
 */
export function isMobileLayout(): boolean {
	return jQuery(window).width() <= 1024;
}

/**
 * Map tab data-tab attribute value to the corresponding content panel ID.
 * Some tab names do not directly match their panel IDs.
 */
function getContentPanelIdFromTab(tabName: string): string {
	const tabToPanelMap: Record<string, string> = {
		style: 'ssb-configurator-accordion-style',
		layouts: 'ssb-configurator-accordion-layouts',
		sizes: 'ssb-configurator-accordion-sizes',
		'sides-ends': 'ssb-configurator-accordion-sides-ends',
		appearance: 'ssb-configurator-accordion-appearance',
		materials: 'materials-content',
		color: 'colors-content',
		exterior: 'ssb-configurator-accordion-upgrades',
		interior: 'ssb-configurator-accordion-interior',
		upgrades: 'ssb-configurator-accordion-upgrades-new',
	};

	return tabToPanelMap[tabName] || `ssb-configurator-accordion-${tabName}`;
}

/**
 * Scroll the tab bar horizontally to keep the given tab centered in view.
 */
function scrollTabIntoView(tabContainer: JQuery, tab: JQuery): void {
	const containerWidth = tabContainer.outerWidth() || 0;
	const tabLeft = tab.position()?.left || 0;
	const tabWidth = tab.outerWidth() || 0;
	const currentScroll = tabContainer.scrollLeft() || 0;

	// Calculate the scroll position to center the tab within the container
	const targetScroll = currentScroll + tabLeft - containerWidth / 2 + tabWidth / 2;
	tabContainer.stop().animate({ scrollLeft: targetScroll }, 300);
}

/**
 * Sets the initial active tab and shows its corresponding content panel.
 */
function initActiveTab(
	tabContainer: JQuery,
	allTabs: JQuery,
	mobileActiveTab: string,
	mobileActiveContent: string,
): void {
	let targetTab = tabContainer.find(`.ssb-tab-mobile-item.${mobileActiveTab}`);

	if (!targetTab.length) {
		targetTab = allTabs.filter(':visible').first();
	}

	if (targetTab.length) {
		targetTab.addClass(mobileActiveTab);
		const tabName = targetTab.data('tab');
		const panelId = getContentPanelIdFromTab(tabName);
		jQuery(`#${panelId}`).addClass(mobileActiveContent);
	}
}

/**
 * Bind click events for mobile tabs to handle switching between panels.
 */
function bindTabClickEvents(
	tabContainer: JQuery,
	allTabs: JQuery,
	allPanels: JQuery,
	mobileActiveTab: string,
	mobileActiveContent: string,
): void {
	const handleTabClick = (event: JQuery.ClickEvent) => {
		const clickedTab = jQuery(event.currentTarget);
		const tabName = clickedTab.data('tab');

		if (!tabName || clickedTab.hasClass(mobileActiveTab)) {
			return;
		}

		// Update active tab state
		allTabs.removeClass(mobileActiveTab);
		clickedTab.addClass(mobileActiveTab);

		// Show the corresponding content panel and hide the rest
		allPanels.removeClass(mobileActiveContent);
		const panelId = getContentPanelIdFromTab(tabName);
		jQuery(`#${panelId}`).addClass(mobileActiveContent);

		// Scroll tab bar to keep the active tab visible and centered
		scrollTabIntoView(tabContainer, clickedTab);

		// Scroll the summary container to snap the tab bar to its sticky position
		const summary = tabContainer.closest('.summary');
		if (summary.length) {
			const contentContainer = jQuery('.ssb-configurator-contents-mobile');
			let targetTop = 0;

			if (contentContainer.length) {
				// Calculate the original static offsetTop of the tab container by using the static content container.
				// This avoids the bug where offsetTop of a sticky element returns the currently stuck position.
				targetTop =
					(contentContainer.get(0)?.offsetTop || 0) -
					(tabContainer.outerHeight(true) || 0);
			} else {
				targetTop = tabContainer.get(0)?.offsetTop || 0;
			}

			// We scroll to targetTop to align the tab container exactly where it originally lived.
			summary.animate({ scrollTop: targetTop }, 300);
		}

		// Scroll the content part to top
		const activePanel = jQuery(`#${panelId}`);
		activePanel.find('.ssb-configurator-panel-content').scrollTop(0);

		// Dispatch event for other scripts to handle tab switch
		window.dispatchEvent(
			new CustomEvent('mobile-tab-changed', {
				detail: { tabName },
			}),
		);
	};

	// Use off().on() to prevent duplicate events if initialized multiple times
	tabContainer
		.off('click.mobileTab')
		.on('click.mobileTab', '.ssb-tab-mobile-item', handleTabClick);
}

/**
 * Initialize the mobile configurator tab switching behavior.
 * Handles click events on tab items and shows/hides the corresponding content panels.
 */
export function initConfiguratorMobileTabs(): void {
	const tabContainer = jQuery('.ssb-configurator-tabs-mobile');
	const contentContainer = jQuery('.ssb-configurator-contents-mobile');

	if (!tabContainer.length || !contentContainer.length) {
		return;
	}

	const mobileActiveContent = 'mobile-active-content';
	const mobileActiveTab = 'mobile-active-tab';
	const allPanels = contentContainer.find('.ssb-configurator-panel');
	const allTabs = tabContainer.find('.ssb-tab-mobile-item');

	// Hide all panels and show only the active tab's panel on init
	allPanels.removeClass(mobileActiveContent);

	initActiveTab(tabContainer, allTabs, mobileActiveTab, mobileActiveContent);

	// Handle tab click events
	bindTabClickEvents(tabContainer, allTabs, allPanels, mobileActiveTab, mobileActiveContent);

	initMobileMaterialsV2();
}

/**
 * Initialize the split-view drag handle to resize the canvas and summary sections.
 * Supports both touch and mouse events for dragging.
 */
export function initSplitViewResize(): void {
	const splitView = document.querySelector('.split-view') as HTMLElement;
	if (!splitView) {
		return;
	}

	const canvasWrapper = document.querySelector('.ssb-model-canvas-wrapper') as HTMLElement;
	const summary = document.querySelector(
		'.woocommerce-page.single div.product div.summary',
	) as HTMLElement;

	if (!canvasWrapper || !summary) {
		return;
	}

	// Get the navbar height for available space calculation
	const getNavbarHeight = (): number => {
		const navbar = document.querySelector('#wrapper-navbar nav.navbar') as HTMLElement;
		return navbar ? navbar.offsetHeight : 0;
	};

	// Minimum and maximum ratio for canvas height (20% - 80%)
	const MIN_RATIO = 0.2;
	const MAX_RATIO = 0.8;

	let isDragging = false;
	let startY = 0;
	let startCanvasHeight = 0;
	let rafId: number | null = null;

	/**
	 * Get the Y position from touch or mouse event.
	 */
	const getEventY = (e: TouchEvent | MouseEvent): number => {
		if ('touches' in e) {
			return e.touches[0].clientY;
		}
		return e.clientY;
	};

	/**
	 * Apply new heights to canvas and summary based on drag position.
	 */
	const applyHeights = (canvasHeight: number): void => {
		const availableHeight = window.innerHeight - getNavbarHeight();
		const minHeight = availableHeight * MIN_RATIO;
		const maxHeight = availableHeight * MAX_RATIO;

		// Clamp canvas height within bounds
		const clampedHeight = Math.max(minHeight, Math.min(maxHeight, canvasHeight));
		const summaryHeight = availableHeight - clampedHeight;

		canvasWrapper.style.setProperty('height', `${clampedHeight}px`, 'important');
		summary.style.setProperty('height', `${summaryHeight}px`, 'important');

		// Update CSS variable for popup overlay top position
		const popupTop = getNavbarHeight() + clampedHeight;
		document.documentElement.style.setProperty('--ssb-popup-top', `${popupTop}px`);
	};

	/**
	 * Handle drag start for both touch and mouse events.
	 */
	const onDragStart = (e: TouchEvent | MouseEvent): void => {
		isDragging = true;
		startY = getEventY(e);
		startCanvasHeight = canvasWrapper.offsetHeight;

		splitView.classList.add('dragging');
		document.body.classList.add('is-resizing');

		// Prevent scrolling while dragging
		e.preventDefault();
	};

	/**
	 * Handle drag move for both touch and mouse events.
	 */
	const onDragMove = (e: TouchEvent | MouseEvent): void => {
		if (!isDragging) {
			return;
		}

		const currentY = getEventY(e);
		const deltaY = currentY - startY;
		const newCanvasHeight = startCanvasHeight + deltaY;

		// Batch DOM updates via requestAnimationFrame for performance
		if (rafId) {
			cancelAnimationFrame(rafId);
		}

		rafId = requestAnimationFrame(() => {
			applyHeights(newCanvasHeight);
			rafId = null;
		});

		e.preventDefault();
	};

	/**
	 * Handle drag end and trigger BabylonJS engine resize.
	 */
	const onDragEnd = (): void => {
		if (!isDragging) {
			return;
		}

		isDragging = false;

		if (rafId) {
			cancelAnimationFrame(rafId);
			rafId = null;
		}

		splitView.classList.remove('dragging');
		document.body.classList.remove('is-resizing');

		// Trigger BabylonJS engine resize to re-render at the new canvas dimensions
		window.dispatchEvent(new Event('resize'));
	};

	// Touch events
	splitView.addEventListener('touchstart', onDragStart, { passive: false });
	document.addEventListener('touchmove', onDragMove, { passive: false });
	document.addEventListener('touchend', onDragEnd);

	// Mouse events (for desktop testing)
	splitView.addEventListener('mousedown', onDragStart);
	document.addEventListener('mousemove', onDragMove);
	document.addEventListener('mouseup', onDragEnd);
}

interface MobileMaterialsLayoutOptions {
	wrapperId: string;
	listingClass: string;
	accordionId: string;
	backLabel: string;
}

/**
 * Initialize the mobile materials V2 layout for a specific wrapper.
 * Moves the accordion into .wrapper-bottom-sheet to overlay the summary on mobile split view.
 */
export function initMobileMaterialsV2Layout(options: MobileMaterialsLayoutOptions): void {
	const wrapper = jQuery(`#${options.wrapperId}`);
	if (!wrapper.length) return;

	const listingElement = wrapper.find(`.${options.listingClass}`);
	const accordion = jQuery(`#${options.accordionId}`);
	const popupElement = jQuery('.wrapper-bottom-sheet');

	if (!listingElement.length || !accordion.length) return;

	// Move accordion to .wrapper-bottom-sheet container so it overlays the summary
	if (popupElement.length && accordion.parent().attr('id') === options.wrapperId) {
		accordion.detach().appendTo(popupElement);
		accordion.addClass('ssb-materials-edit-overlay');
	}

	let hideAccordionTimeout: any = null;

	/**
	 * Get the list of valid group class names from the listing items.
	 */
	const getValidGroups = (): string[] => {
		const validGroups: string[] = [];
		listingElement.find('.ssb-material-selected-item').each(function () {
			const target = jQuery(this).attr('data-target');
			if (target) validGroups.push(target);
		});
		return validGroups;
	};

	/**
	 * Show the listing view and hide the edit overlay.
	 */
	const showListing = (): void => {
		listingElement.show();
		accordion.removeClass('is-active');

		const panelContent = accordion.find('.ssb-configurator-panel-content').first();
		panelContent.removeClass('v2-is-editing');
		panelContent.find('> .ssb-configurator-group').removeClass('v2-edit-active');

		if (hideAccordionTimeout) clearTimeout(hideAccordionTimeout);
		hideAccordionTimeout = setTimeout(() => {
			accordion.hide();
		}, 300);
	};

	/**
	 * Get the active name of the selected option, including the color code if applicable.
	 */
	const getActiveName = (activeOption: JQuery<HTMLElement>): string => {
		if (!activeOption.length) return '';
		let activeName = activeOption.find('.ssb-option-name').text().trim();
		if (activeOption.attr('data-texture-type') === 'color_picker') {
			const colorCode = activeOption.find('.ssb-option-color-picker').val() as string;
			if (colorCode) {
				activeName = `${activeName} - ${colorCode}`;
			}
		}
		return activeName;
	};

	/**
	 * Show the edit overlay for a specific group.
	 */
	const showEdit = (targetClass: string): void => {
		const header = accordion.find('.ssb-materials-edit-header');
		const panelContent = accordion.find('.ssb-configurator-panel-content').first();

		// Sync popup top position with current summary position before showing
		const summaryEl = document.querySelector(
			'.woocommerce-page.single div.product div.summary',
		);
		if (summaryEl) {
			document.documentElement.style.setProperty(
				'--ssb-popup-top',
				`${summaryEl.getBoundingClientRect().top}px`,
			);
		}

		listingElement.hide();
		accordion.show();

		if (hideAccordionTimeout) clearTimeout(hideAccordionTimeout);

		// Force reflow for CSS transition
		void accordion[0].offsetWidth;
		accordion.addClass('is-active');

		panelContent.addClass('v2-is-editing');
		panelContent.find('> .ssb-configurator-group').removeClass('v2-edit-active');

		const targetGroup = panelContent.find(`> .${targetClass}`);
		targetGroup.addClass('v2-edit-active');

		// Do not hide the group title since we use it to show the active name

		// Update Header Title
		const inputTitleEl = targetGroup.find('input.mobile-group-title');
		const titleEl = targetGroup.find('.ssb-configurator-group-name');
		let groupTitle = '';

		if (inputTitleEl.length) {
			groupTitle = inputTitleEl.val() as string;
		} else {
			groupTitle = titleEl.attr('data-name') as string;
			if (!groupTitle) {
				groupTitle = titleEl.text().trim();
				titleEl.attr('data-name', groupTitle);
			}
		}
		header.find('.ssb-materials-edit-title').text(groupTitle);

		// Update Active Name
		let activeOption = targetGroup.find('li.ssb-option.active');
		if (!activeOption.length) {
			activeOption = targetGroup.find('li.ssb-option').first();
		}
		if (activeOption.length) {
			const activeName = getActiveName(activeOption);
			titleEl.text(activeName);
		}

		// Determine Next or Finish
		const validGroups = getValidGroups();
		const currentIndex = validGroups.indexOf(targetClass);

		// Determine Prev or Back to List
		const backBtn = header.find('.ssb-materials-back-btn');
		if (currentIndex > 0) {
			const prevClass = validGroups[currentIndex - 1];
			backBtn.html('<i class="fas fa-chevron-left"></i> Back');
			backBtn.attr('data-target', prevClass);
			backBtn.attr('data-action', 'prev');
		} else {
			backBtn.html(`<i class="fas fa-chevron-left"></i> ${options.backLabel}`);
			backBtn.attr('data-target', '');
			backBtn.attr('data-action', 'back-to-list');
		}

		// Determine Next or Finish
		const nextBtn = header.find('.ssb-materials-next-btn');
		if (currentIndex !== -1 && currentIndex < validGroups.length - 1) {
			const nextClass = validGroups[currentIndex + 1];
			nextBtn.html('Next <i class="fas fa-chevron-right"></i>');
			nextBtn.attr('data-target', nextClass);
			nextBtn.attr('data-action', 'next');
		} else {
			nextBtn.html('Finish <i class="fas fa-chevron-right"></i>');
			nextBtn.attr('data-target', '');
			nextBtn.attr('data-action', 'finish');
		}
	};

	const updateLayout = (): void => {
		const panelContent = accordion.find('.ssb-configurator-panel-content').first();
		listingElement.empty();

		panelContent.find('> .ssb-configurator-group').each(function () {
			const group = jQuery(this);

			// If group is hidden via inline style, skip it
			// We only check inline style because legacy script.js controls it via .show() / .hide()
			if (group[0].style.display === 'none') {
				return;
			}

			const titleEl = group.find('.ssb-configurator-group-name');
			let groupTitle = (group.find('.mobile-group-title').val() as string) || '';
			if (!groupTitle) {
				groupTitle = titleEl.attr('data-name') || '';
			}
			if (!groupTitle) {
				groupTitle = titleEl.text().trim();
				titleEl.attr('data-name', groupTitle);
			}
			const groupClassAttr = group.attr('class') || '';
			const groupClass = groupClassAttr.split(' ').find((c) => c.startsWith('group-'));

			let activeOption = group.find('li.ssb-option.active');
			if (!activeOption.length) {
				activeOption = group.find('li.ssb-option').first();
			}
			if (!activeOption.length) return;

			const swatchEl = activeOption.find('.ssb-option-swatch');
			const swatchBgImage = swatchEl.css('background-image');
			const swatchBgColor = swatchEl.css('background-color');
			const activeName = getActiveName(activeOption);

			// Keep the group header in sync with the current active option name
			titleEl.text(activeName);

			let imgStyle = '';
			if (swatchBgImage && swatchBgImage !== 'none') {
				imgStyle = `background-image: ${swatchBgImage}`;
			} else if (
				swatchBgColor &&
				swatchBgColor !== 'rgba(0, 0, 0, 0)' &&
				swatchBgColor !== 'transparent'
			) {
				imgStyle = `background-color: ${swatchBgColor}`;
			}

			const imgHtml = imgStyle
				? `<div class="ssb-material-selected-img" style='${imgStyle}'></div>`
				: '';

			const itemHtml = `
				<div class="ssb-material-selected-item" data-target="${groupClass}">
					${imgHtml}
					<div class="ssb-material-selected-info">
						<div class="label">${groupTitle}:</div>
						<div class="value">${activeName}</div>
					</div>
					<div class="ssb-material-selected-arrow">
						<i class="fas fa-chevron-right"></i>
					</div>
				</div>
			`;

			listingElement.append(itemHtml);
		});
	};

	// Initial render
	showListing();
	updateLayout();

	// Watch for dynamic style (visibility) changes on groups
	const panelContent = accordion.find('.ssb-configurator-panel-content').first();
	let observerTimeout: number | null = null;
	const observer = new MutationObserver((mutationsList) => {
		let shouldUpdate = false;
		for (const mutation of mutationsList) {
			if (mutation.type === 'attributes') {
				if (mutation.attributeName === 'style' || mutation.attributeName === 'class') {
					shouldUpdate = true;
					break;
				}
			}
		}
		if (shouldUpdate) {
			if (observerTimeout) clearTimeout(observerTimeout);
			observerTimeout = setTimeout(() => {
				updateLayout();
			}, 50) as unknown as number;
		}
	});

	// Watch for visibility changes on groups
	panelContent.find('> .ssb-configurator-group').each(function () {
		observer.observe(this, { attributes: true, attributeFilter: ['style'] });
	});

	// Watch for active class changes on options
	panelContent.find('.ssb-option').each(function () {
		observer.observe(this, { attributes: true, attributeFilter: ['class'] });
	});

	// Watch for color changes via color picker on swatches
	panelContent.find('.ssb-option-swatch').each(function () {
		observer.observe(this, { attributes: true, attributeFilter: ['style'] });
	});

	// Watch for changes in materials to update the selected layout
	// Use off().on() to prevent duplicate events on same elements if called multiple times,
	// although for different wrappers they are separate.
	jQuery(document)
		.off(`click.mobileMaterialsV2Layout-${options.accordionId}`)
		.on(
			`click.mobileMaterialsV2Layout-${options.accordionId}`,
			`#${options.accordionId} .ssb-option`,
			function () {
				setTimeout(() => {
					updateLayout();
				}, 50);
			},
		);

	// Handle clicks on listing items
	listingElement
		.off(`click.materialsListing`)
		.on('click.materialsListing', '.ssb-material-selected-item', function () {
			const targetClass = jQuery(this).attr('data-target');
			if (targetClass) {
				showEdit(targetClass);
			}
		});

	// Handle Back button
	accordion
		.off(`click.materialsBack`)
		.on('click.materialsBack', '.ssb-materials-back-btn', function () {
			const action = jQuery(this).attr('data-action');
			if (action === 'prev') {
				const target = jQuery(this).attr('data-target');
				if (target) showEdit(target);
			} else {
				showListing();
			}
		});

	// Handle Next/Finish button
	accordion
		.off(`click.materialsNext`)
		.on('click.materialsNext', '.ssb-materials-next-btn', function () {
			const action = jQuery(this).attr('data-action');
			if (action === 'next') {
				const target = jQuery(this).attr('data-target');
				if (target) showEdit(target);
			} else {
				showListing();
			}
		});
}

export function initMobileMaterialsV2(): void {
	initMobileMaterialsV2Layout({
		wrapperId: 'materials-content',
		listingClass: 'ssb-materials-listing',
		accordionId: 'ssb-configurator-accordion-materials',
		backLabel: 'Materials',
	});

	initMobileMaterialsV2Layout({
		wrapperId: 'interior-materials-content',
		listingClass: 'ssb-interior-materials-listing',
		accordionId: 'ssb-configurator-accordion-interior-materials',
		backLabel: 'Interior',
	});

	initMobileMaterialsV2Layout({
		wrapperId: 'colors-content',
		listingClass: 'ssb-colors-listing',
		accordionId: 'ssb-configurator-accordion-colors',
		backLabel: 'Colors',
	});

	initMobileMaterialsV2Layout({
		wrapperId: 'interior-colors-content',
		listingClass: 'ssb-interior-colors-listing',
		accordionId: 'ssb-configurator-accordion-interior-colors',
		backLabel: 'Interior',
	});
}

export interface MobileBottomSheetOptions {
	contentElement: JQuery;
	title: string;
	sheetClass?: string;
	onClose?: () => void;
	onOpen?: () => void;
}

/**
 * Track original DOM position of content elements so they can be restored on close.
 */
const bottomSheetOriginalParents = new WeakMap<
	HTMLElement,
	{ parent: HTMLElement; nextSibling: Node | null }
>();

/**
 * Open a dialog content element as a mobile bottom sheet inside .wrapper-bottom-sheet.
 * Moves the content into a slide-up overlay, similar to the materials/colors edit pattern.
 */
export function openMobileBottomSheet(options: MobileBottomSheetOptions): void {
	const { contentElement, title, sheetClass, onClose, onOpen } = options;
	const popupElement = jQuery('.wrapper-bottom-sheet');
	if (!popupElement.length || !contentElement.length) return;

	// Check if already in a bottom sheet to prevent duplicates
	const existingOverlay = contentElement.closest('.ssb-bottom-sheet-overlay');
	if (existingOverlay.length) {
		existingOverlay.addClass('is-active');
		if (onOpen) onOpen();
		return;
	}

	// Store original position for restoration on close
	const el = contentElement[0];
	if (!bottomSheetOriginalParents.has(el)) {
		bottomSheetOriginalParents.set(el, {
			parent: el.parentElement!,
			nextSibling: el.nextSibling,
		});
	}

	// Sync popup top position with current canvas bottom
	const summaryEl = document.querySelector('.woocommerce-page.single div.product div.summary');
	if (summaryEl) {
		document.documentElement.style.setProperty(
			'--ssb-popup-top',
			`${summaryEl.getBoundingClientRect().top}px`,
		);
	}

	// Build the overlay wrapper
	const extraClass = sheetClass ? ` ${sheetClass}` : '';
	const overlay = jQuery(`
		<div class="ssb-bottom-sheet-overlay${extraClass}">
			<div class="ssb-bottom-sheet-header">
				<span class="ssb-bottom-sheet-title">${title || ''}</span>
				<button class="ssb-bottom-sheet-close" type="button">Close</button>
			</div>
			<div class="ssb-bottom-sheet-content"></div>
		</div>
	`);

	// Move the content element into the overlay
	overlay.find('.ssb-bottom-sheet-content').append(contentElement);
	popupElement.append(overlay);
	contentElement.show();

	// Force reflow then animate in
	void overlay[0].offsetWidth;
	overlay.addClass('is-active');

	// Close button delegates to the onClose callback (e.g., closeEditComponent)
	overlay.find('.ssb-bottom-sheet-close').on('click', function () {
		if (onClose) {
			onClose();
		} else {
			closeMobileBottomSheet(contentElement);
		}
	});

	jQuery('body').addClass('dialog-opened');

	if (onOpen) onOpen();
}

/**
 * Close a mobile bottom sheet and restore the content element to its original DOM position.
 */
export function closeMobileBottomSheet(contentElement: JQuery): void {
	if (!contentElement || !contentElement.length) return;

	const overlay = contentElement.closest('.ssb-bottom-sheet-overlay');
	if (!overlay.length) return;

	overlay.removeClass('is-active');

	// After CSS transition completes, restore element and remove overlay
	setTimeout(() => {
		const el = contentElement[0];
		const original = bottomSheetOriginalParents.get(el);
		if (original) {
			if (original.nextSibling) {
				jQuery(original.nextSibling).before(contentElement);
			} else {
				jQuery(original.parent).append(contentElement);
			}
			contentElement.hide();
			bottomSheetOriginalParents.delete(el);
		}

		overlay.remove();
	}, 300); // Match the CSS transition duration
}

/**
 * Check if an element is currently displayed inside a mobile bottom sheet.
 */
export function isInBottomSheet(element: JQuery): boolean {
	return element.closest('.ssb-bottom-sheet-overlay').length > 0;
}

/**
 * Initialize the mobile V2 model controls popup toggle and outside click behavior.
 */
export function initMobileModelControls(): void {
	const modelControls = jQuery('.model-controls');
	if (!modelControls.length) {
		return;
	}

	// Toggle controls popup when clicking the toggle button
	modelControls
		.off('click.modelControlsToggle')
		.on('click.modelControlsToggle', '.model-controls-toggle', function (e) {
			e.preventDefault();
			e.stopPropagation();
			const isActive = modelControls.hasClass('active');
			if (isActive) {
				modelControls.removeClass('active');
				jQuery('.center-item-popup').removeClass('active');
			} else {
				modelControls.addClass('active');
			}
		});

	// Close controls popup when clicking Full View, AR View, or Center Items confirm button
	modelControls
		.off('click.modelControlsActions')
		.on(
			'click.modelControlsActions',
			'#fullscreen, #ar-view-shed-mobile, #ar-view-shed-desktop, #center-item-button',
			function () {
				modelControls.removeClass('active');
			},
		);

	// Close controls popup when clicking outside .model-controls
	jQuery(document)
		.off('click.modelControlsOutside')
		.on('click.modelControlsOutside', function (e) {
			if (
				!modelControls.is(e.target as any) &&
				modelControls.has(e.target as any).length === 0
			) {
				modelControls.removeClass('active');
			}
		});
}
